module.exports = __webpack_public_path__ + "img/trash-alt.8e91d188.svg";